export const RESOURCE = {
    CART: 'cart',
    CUSTOMERS: 'customers',
    DISCOUNT: 'discount',
    USERS: 'users',
    INVENTORY: 'inventory',
    INVOICE: 'invoice',
    ORDERS: 'orders',
    PAYMENTS: 'payments',
    PRODUCTS: 'products',
    PURCHASES: 'purchases',
    SUPPLIERS: 'suppliers',
    REPORTS: 'reports',
    ADJUSTMENT: 'adjustment',
    WHOLESALE: 'wholesale',
    SETTINGS: 'settings',
    RETURN: 'return',
    EXPENSE: 'expense',
    CASHBOX: 'cashbox',
} as const;

export const PERMISSION_TYPE = {
    Read: 'read',
    Create: 'create',
    Update: 'update',
    Delete: 'delete',
} as const;
